import { render, staticRenderFns } from "./albumSpuShopIds.vue?vue&type=template&id=7d0cf118&scoped=true"
import script from "./albumSpuShopIds.vue?vue&type=script&lang=ts"
export * from "./albumSpuShopIds.vue?vue&type=script&lang=ts"
import style0 from "./albumSpuShopIds.vue?vue&type=style&index=0&id=7d0cf118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0cf118",
  null
  
)

export default component.exports